import script from "./Pay.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pay.vue?vue&type=script&setup=true&lang=ts"

import "./Pay.vue?vue&type=style&index=0&id=0cf3d88b&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cf3d88b"]])

export default __exports__